import { render } from "./ContactPhone.vue?vue&type=template&id=63485ba8&bindings={\"phone\":\"data\",\"next\":\"options\"}"
import script from "./ContactPhone.vue?vue&type=script&lang=js"
export * from "./ContactPhone.vue?vue&type=script&lang=js"
script.render = render

export default script